import React, { JSX } from 'react';
import { HeadItem, ListRowItem, NestedListItem, Sorting } from './types';
import { IsoDropdownItem } from '../UI/Dropdown/Dropdown';

export const listSegmentation = <L extends ListRowItem>(
  listRowItem: L,
  itemsInRow?: number,
  isDesktop?: boolean
): NestedListItem<L>[] => {
  if (!!itemsInRow) {
    const nestedList: Array<NestedListItem<L>> = [];
    let nestedIdx = -1;
    Object.keys(listRowItem)
      .filter(
        key =>
          (!isDesktop && !listRowItem[key].hideInMobile) ||
          (isDesktop && !listRowItem[key].hideInDesktop)
      )
      .forEach((key: string, idx: number) => {
        const listRowPropertyObject = { [key]: listRowItem[key] } as L;
        if (idx % itemsInRow === 0) {
          ++nestedIdx;
          nestedList[nestedIdx] = {
            id: nestedIdx,
            list: { ...listRowPropertyObject },
            className: listRowItem[key]?.className || ''
          };
        } else {
          nestedList[nestedIdx] = {
            id: nestedList[nestedIdx].id,
            list: { ...nestedList[nestedIdx].list, ...listRowPropertyObject },
            className: listRowItem[key]?.className || ''
          };
        }
      });
    return nestedList;
  } else {
    return Object.keys(listRowItem)
      .filter(
        key =>
          (!isDesktop && !listRowItem[key].hideInMobile) ||
          (isDesktop && !listRowItem[key].hideInDesktop)
      )
      .map((key: string) => ({
        id: key,
        list: { [key]: listRowItem[key] } as L,
        className: listRowItem[key]?.className || ''
      }));
  }
};

export const SimpleListDropdownItem = ({
  headItem,
  sortString,
  currentSorting,
  handleSortClick,
  isAscDirection
}: {
  headItem: HeadItem;
  sortString: string;
  currentSorting: Sorting;
  handleSortClick: (sortProp: string, isAscDirection: boolean) => void;
  isAscDirection: boolean;
}): JSX.Element => {
  return (
    <IsoDropdownItem
      className={
        headItem?.sortProp === currentSorting.sortProp &&
        currentSorting.isAscDirection === isAscDirection
          ? 'simple-list__sort-dropdown--selected'
          : ''
      }
      onClick={(): void => handleSortClick(headItem.sortProp || '', isAscDirection)}
    >{`${headItem.value} ${sortString}`}</IsoDropdownItem>
  );
};
